<template>
  <div class="row step-selector no-gutters">
    <div class="step-inputs col-lg-8">

      <div class="page-intro">
        <h3 v-if="builder">Build Your Deal</h3>
        <h3 v-if="!builder">Hot Deals</h3>
      </div>
      
      <vue-product-selector :builder="builder" :sim="sim" :product_type="'deal'" :allowAddons="true" :callCentre="true"/>

      <div class="page-controls">
        <div class="row">
          <div class="col">
            <button
              type="button"
              class="btn btn-block btn-dark next"
              v-on:click="nextStep"
              :disabled="!validSelection"
            >
              Continue
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

    </div>
    <div class="col-lg-4 deal-info-content">
      <vue-deal-info :builder="builder" />
    </div>
  </div>
</template>

<script>
import EventBus from "@/components/shared/event-bus";
import store from "@/store";
import SimModel from "@/models/sim.model";

import VueProductSelector from "@/components/elements/vue-product-selector";
import VueDealInfo from "@/components/elements/vue-deal-info";
import { CART_UPDATE_CURRENT_ITEM } from "@/store/actions.type";

export default {
  name: "product-selector",
  components: {
    "vue-product-selector": VueProductSelector,
    "vue-deal-info": VueDealInfo,
  },
  props: ["builder"],
  data: function() {
    return {
      sim: new SimModel(store.state.cart.current_sim)
    };
  },
  computed: {    
    validSelection() {
      return !this.isEmpty(store.state.cart.current_sim.deal);
    }
  },
  methods: {
    nextStep() {
      EventBus.$emit("next-step", true);
    },
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },    
  },
  mounted() {
    var self = this;    
    var iccid = self.$route.params.iccid;
    if (typeof iccid != "undefined" && iccid != "" && iccid) {
      self.sim.iccid = iccid;
    }

    var selected_deal = self.$route.params.deal;
    if (typeof selected_deal != "undefined" && selected_deal != "" && selected_deal) {      
      
      EventBus.$emit('hide_menu', true); 
      
      store.state.products.products.deals.forEach(deal => {
        if (deal.deal_name_id == selected_deal) {
          self.sim.deal = deal;          
          self.$log.debug("SIM CHANGE", self.sim);          
          store.dispatch(CART_UPDATE_CURRENT_ITEM, self.sim);
          self.nextStep();
        } 
      });
    }
  }
};
</script>